<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form label-width="80px" ref="form" :model="queryParams">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="groupType"
              label="合成类型："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.groupType"
                placeholder="请选择合成类型"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in groupTypeArray"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品名称：" prop="proName">
              <el-input
                size="small"
                v-model="queryParams.proName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品编号：" prop="designId">
              <el-input
                size="small"
                v-model="queryParams.designId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="产品名称：" prop="designProName">
              <el-input
                size="small"
                v-model="queryParams.designProName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="remitFlag"
              label="是否汇出："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.remitFlag"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option label="是" value="1"> </el-option>
                <el-option label="否" value="0"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="text-align: right">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <el-row class="table-menu">
        <el-col :span="8">
          <el-dropdown
            placement="top"
            style="margin: 0 17px 0 0"
            @command="handleCommandExport"
          >
            <el-button size="small" type="primary">
              汇出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="amazon">亚马逊汇出</el-dropdown-item>
              <el-dropdown-item command="shopify">shopify汇出</el-dropdown-item>
              <el-dropdown-item command="shopline"
                >shopline汇出</el-dropdown-item
              >
              <el-dropdown-item command="shoplazza">店匠汇出</el-dropdown-item>
              <el-dropdown-item command="common">通用模板汇出</el-dropdown-item>
              <el-dropdown-item command="lazada">lazada汇出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="false"
            style="margin: 0 17px 0 0"
            @click="handleSendData"
            size="small"
            type="success"
            >数据推送</el-button
          >
          <el-button @click="handleGroup" size="small" type="primary"
            >设置组合商品</el-button
          >
          <el-button type="danger" size="small" @click="handleDelItem"
            >批量删除</el-button
          >
          <el-button @click="handleJumpToBin" type="text"
            >回收站 <i class="el-icon-delete"></i
          ></el-button>
        </el-col>
        <el-col
          :span="16"
          style="text-align: right; height: 36px; line-height: 36px"
        >
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
      <div>
        <el-row style="display: flex; flex-wrap: wrap; background-color: white">
          <el-col
            :span="12"
            style="
              display: flex;
              padding-left: 20px;
              color: #333333;
              font-size: 14px;
              align-items: center;
            "
          >
            <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-table
          ref="table"
          :data="tableData"
          class="clain-tab"
          border
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            label="产品编号"
            width="169px"
            align="center"
            prop="designId"
          >
            <template slot-scope="scope">
              <span
                @click="handleJumpDesign(scope.row)"
                class="el-button--text"
                style="cursor: pointer"
                >{{ scope.row.pId }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="合成类型" align="center" prop="designId">
            <template slot-scope="scope">
              <span>{{
                scope.row.groupType == "01" ? "多素材组合" : "单素材组合"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column width="160" align="center" label="设计图片">
            <template slot-scope="scope">
              <el-row type="flex">
                <el-col>
                  <el-popover
                    placement="right"
                    trigger="hover"
                    :close-delay="closeDelay"
                  >
                    <img
                      class="img-big"
                      :src="
                        `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                      "
                      style="width: 300px; height: 300px"
                    />
                    <img
                      slot="reference"
                      class="img-small"
                      :src="
                        `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                      "
                    />
                  </el-popover>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column width="200" align="center" label="主题名称">
            <template slot-scope="scope">
              <el-row type="flex">
                <div
                  :title="scope.row.designEngProName"
                  style="
                    width: 189px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                    text-align: left;
                  "
                >
                  {{ scope.row.designEngProName }}
                  <i
                    @click="handleShowEdit(scope.row)"
                    style="color: #409eff; cursor: pointer"
                    class="el-icon-edit"
                  ></i>
                </div>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="价格" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.price }}</span>
            </template>
          </el-table-column>

          <el-table-column label="汇出店铺" align="center" prop="shopList">
            <template slot-scope="scope">
              <div
                :title="record"
                class="text-ellipsis"
                v-for="(record, index) in scope.row.shopList"
                :key="index"
              >
                {{ record }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="添加时间"
            align="center"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="105"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.editFlag == '1' && scope.row.groupType == '01'"
                type="text"
                size="small"
                @click="handleNotGroup(scope.row)"
                >取消组合</el-button
              ><br />
              <el-button
                v-if="scope.row.editFlag == '1'"
                type="text"
                size="small"
                @click="handleShowEdit(scope.row)"
                >编辑</el-button
              ><br />
              <el-button
                type="text"
                size="small"
                @click="handleShowCart(scope.row)"
                >加入购物车</el-button
              ><br />
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="加入购物车"
      width="600px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="cartDialogVisible"
    >
      <div style="height: 460px; overflow-y: auto; overflow-x: hidden">
        <div v-for="(record, index) in cartArray" :key="index">
          <div class="product-title">{{ record.proName }}</div>
          <el-form ref="form" label-width="80px">
            <el-row :gutter="24">
              <el-col :span="9">
                <div
                  style="
                    border: 1px solid #e3e3e3;
                    width: 180px;
                    height: 180px;
                    padding: 5px;
                  "
                >
                  <img
                    :src="
                      `${record.currentSku.mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
              </el-col>
              <el-col :span="15">
                <div class="sku-attr">
                  <div class="sku-name">颜色</div>
                  <div class="sku-detail">
                    <a
                      :style="{ background: dictMap['color'][color] }"
                      :class="{
                        'is-select': record.currentAttr.color === color,
                      }"
                      @click="handleSelectColor(record, color)"
                      class="sku-color"
                      v-for="(color, index) in record.attribute['颜色']"
                      :key="index"
                      :title="color"
                    ></a>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">尺码</div>
                  <div class="sku-detail">
                    <a
                      :class="{ 'is-select': record.currentAttr.size === size }"
                      @click="handleSelectSize(record, size)"
                      class="sku-size"
                      v-for="(size, index) in record.attribute['尺码']"
                      :key="index"
                      >{{ size }}</a
                    >
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">数量</div>
                  <div class="sku-detail" style="margin: 0">
                    <el-input-number
                      style="width: 90px"
                      v-model="record.productNum"
                      size="small"
                      controls-position="right"
                      :precision="0"
                      :min="1"
                      :step="1"
                      :max="9999"
                    ></el-input-number>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">单价</div>
                  <div class="sku-detail primary-color" style="margin: 0">
                    <div style="float: left">
                      ￥<span class="sku-price">{{
                        record.currentSku.price
                      }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleJump('/order/myOrder/shopCart')" size="small"
          >查看购物车</el-button
        >
        <el-button @click="handleAddCart()" size="small" type="primary"
          >加入购物车</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      width="800px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="editVisible"
    >
      <div style="height: 460px; overflow-y: auto; overflow-x: hidden">
        <div v-for="(record, index) in cartArray" :key="index">
          <div class="product-title">{{ record.proName }}</div>
          <el-form ref="form" label-width="80px">
            <el-row :gutter="24">
              <el-col :span="9">
                <div
                  style="
                    border: 1px solid #e3e3e3;
                    width: 180px;
                    height: 180px;
                    padding: 5px;
                  "
                >
                  <img
                    :src="
                      `${record.currentSku.mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
                <div>
                  <div style="margin-top: 0" class="sku-attr">
                    <div class="sku-name">颜色</div>
                    <div class="sku-detail">
                      <a
                        class="sku-color"
                        v-for="(color, index) in record.attribute['颜色']"
                        :key="index"
                        >{{ color }}</a
                      >
                    </div>
                  </div>
                  <div style="margin-top: 0" class="sku-attr">
                    <div class="sku-name">尺码</div>
                    <div class="sku-detail">
                      <a
                        class="sku-size"
                        v-for="(size, index) in record.attribute['尺码']"
                        :key="index"
                        >{{ size }}</a
                      >
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="15">
                <div class="sku-attr">
                  <div class="sku-name">产品编号：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    {{ record.designId }}
                    <el-button
                      style="margin: 0 0 0 16px"
                      @click="handleSetParent(record)"
                      v-if="record.designId !== record.groupDesignId"
                      size="small"
                      type="primary"
                      >设为母体</el-button
                    ><span style="color: #409eff; margin: 0 0 0 16px" v-else
                      >已设置为母体</span
                    >
                  </div>
                </div>
                <div v-if="false" class="sku-attr">
                  <div class="sku-name">产品中文名称：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    <el-input v-model="record.proName" size="small"></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">主题名称：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    <el-input
                      v-model="record.engProName"
                      size="small"
                    ></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    <el-button
                      @click="handleModifyDesign(record)"
                      size="small"
                      type="primary"
                      >保存</el-button
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="editVisible = false" size="small" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      width="800px"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible.sync="detailVisible"
    >
      <div>
        <el-table
          id="outTable"
          ref="multipleTable"
          :data="detailData"
          tooltip-effect="dark"
          style="width: 100%"
          lazy
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            prop="groupDesignId"
            label="合成编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="designId"
            label="成品编号"
            align="center"
          ></el-table-column>
          <el-table-column width="177px" align="center" label="设计图片">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <div
                  slot="reference"
                  style="display: float; float: left; margin: 0 8px 0 26px"
                >
                  <img
                    class="img-small"
                    :src="
                      `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                  />
                </div>
                <img
                  class="img-big"
                  :src="
                    `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                  "
                  style="width: 300px; height: 300px"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="templateState" label="主题名称" align="center">
            <template slot-scope="scope">
              <a
                @click.prevent="handleJumpDetailDesign(scope.row.designId)"
                class="templateName"
                >{{ scope.row.designProName }}</a
              >
            </template>
          </el-table-column>
          <el-table-column prop="itemSku" label="定制名称" align="center">
            <template slot-scope="scope">
              <a
                @click.prevent="handleJumpDetailProduct(scope.row.pId)"
                class="templateName"
                >{{ scope.row.proName }}</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button size="small" type="primary" @click="detailVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <vxe-modal
      title="选择待发布店铺"
      v-model="shopSelectDialog"
      width="600"
      height="300"
      showFooter
    >
      <template>
        <div>
          <el-checkbox-group v-model="checkedShops">
            <el-checkbox
              v-for="item in shopList"
              :label="item.shopId"
              :key="item.shopId"
              >{{ item.shopName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="shopSelectDialog = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="submitSelect"
            >确 定</el-button
          >
        </span>
      </template>
    </vxe-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {listYx ,delDesign, updateDesign, getCartInfo, getCartMatchInfo, getDesign, addGroup , cancelGroup, listGroup, setGroupMain, pushDesign} from '@/api/customProduct/design'
import {mapGetters} from 'vuex'
import {addCart, addOrEdit} from '@/api/order/cart'
import {getDesignSku} from '@/api/customProduct/designSku'
import {getAllShop} from "@/api/plat/platType";
import {moveToRelease} from "@/api/customProduct/custom";
import {addToShoppingCart} from'@/api/customProduct/custom'
import CKEditor4 from '@/components/common/CKEditor'

export default {
    name: "product",
    components:{Breadcrumb, CKEditor4},
    data(){
        return{
            // 遮罩层
            loading: true,
            closeDelay:0,
            total:0,
            queryParams:{
                pageNum: 1,
                pageSize: 30,
                timeRange: null,
                designProName: null,
                proName: null,
                productType: null,
                operNo: null,
                remitFlag: null,
                beginTime: null,
                endTime: null,
                groupType: '',
                delFlag: '1',
                designId: ''
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            groupTypeArray: [
              {label : '多素材组合' ,value: '01'},
               {label : '单元素组合' ,value: '02'},
                {label : '简单商品' ,value: '03'},

            ],
            attribute: {},
            currentAttr: {
              color: "",
              size: "",
            },
            currentSku: {},
            mainPic: '',
            productNum: 1,
            tableData:[],
            detailData: [],
            cartArray: [],
            claimCollIds:[],////选中 的产品id
            cartDialogVisible: false,
            cartData: [],
            commodity: {},
            totalCount: 0,
            totalNum: 0.00,
            totalPrice: 0.00,

            /*临时字段区--用于记录*/
            lastId: "",
            platList:[],
            shopSelectDialog:false,
            shopList:[],
            checkAll: false,
            checkedShops: [],
            checkPlat:undefined,
            isIndeterminate: true,
            currentRow:null,
            /* 新增的修改需求用到的字段 */
            colors: [],
            sizes: [],
            form: {},
            singlePrice: '',
            editVisible: false,
            detailVisible: false,
            detailInfo: {},
            editor: null,
            editorConfig:{
              allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
              extraPlugins:['uploadImg'],
              height:'300px',
              toolbar : [
                  [ 'Maximize'],
                  [ 'Bold', 'Italic', 'Underline', 'Strike'],
                  [ 'TextColor', 'BGColor' ],
                  [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                  [ 'HorizontalRule','RemoveFormat'],
                  [ 'Undo', 'Redo' ],
                  '/',
                  [ 'Styles', 'Format', 'Font', 'FontSize' ],
                  [ 'Table'],
                  [ 'uploadImg']
              ],
              language: 'zh-cn',
              wordcount:{
                  showCharCount: true,
              }
            },
              scrollMenu: null,
      objectHeight: null
        }
    },

    computed:{
        rowSelectNum(){
            return this.claimCollIds.length;
        },

        ...mapGetters(['nginx','dictData', 'dictMap']),

    },
    watch:{
        shopSelectDialog(val, oldVal){
            if(!val){
                this.checkedShops = [];
            }
        }
    },
    created() {
        this.getList();
        this.initPlatData();
        this.$nextTick(() => {
      this.scrollMenu = document.querySelector(".table-menu")
      this.objectHeight = this.scrollMenu.offsetTop
      window.addEventListener("scroll", this.handleScroll)
    })
    },
     destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
    methods:{
       handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      console.log(scrollHeight + "," + this.objectHeight)
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 312px)"
        menu.style.padding = '8px 0'
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = '0'
      }
    },
      handleExport(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$router.push('/carry/proCustom/createTemplateData?designId=' + this.claimCollIds.join(','))
      },
      async handleGroup(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$confirm('请确认是否组合商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await addGroup({designId : this.claimCollIds.join(',') })
          this.msgSuccess('设置组合成功')
          this.getList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      handleModifyDesign(row){
        let params = {
          designId: row.designId,
          designProName: row.engProName,
          designEngProName: row.engProName
        }
        updateDesign(params).then(re => {
            this.$message({
                type: 'success',
                message: '保存成功'
            });
            this.getList()
            this.editVisible = false;
          }).catch(err =>{
        });
      },
      handleJumpProduct(row){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: row.pId }} );
        window.open(routeUrl.href, '_blank');
      },
      async  handleJumpDesign(row){
        if(row.groupType == '01'){
          let result = await listGroup({groupDesignId: row.groupDesignId})
          this.detailData = result.rows
          this.detailVisible = true
        }else{
          let routeUrl = ''
          if(row.designId2){
            routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: row.designId2 }} );
          }else{
            routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: row.pId }} );
          }
          window.open(routeUrl.href, '_blank');
        }
      },
      handleJumpDetailDesign(designId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: designId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJumpDetailProduct(pId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: pId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJump(path){
        this.$router.push({path: path})
      },
      async handleAddCart() {
        let cartArray = this._.clone(this.cartArray)
        let form = []
        for(let record of cartArray){
          if(record.shop){
            form.push({
              pId: record.pId,
              designId: record.designId,
              properName: record.currentSku.properName,
              productNum: record.productNum,
              properVal: record.currentSku.properVal,
              skuId:  record.currentSku.skuId,
              productType: record.productType
            })
          }
        }
        if(form.length == 0){
          this.msgError('商品至少需要选择一个')
          return
        }
        try {
          await addCart(form)
          this.$store.dispatch("GetIndexStat")
          this.msgSuccess("加入购物车成功")
        } catch (error) {}
      },
      // table数据
      getList(){
            this.startLoading();
            let params = this._.clone(this.queryParams)
            if(params.timeRange){
              params.beginTime = params.timeRange[0]
              params.endTime = params.timeRange[1]
            }
            delete params["timeRange"]
            listYx(params).then((re) => {
                this.tableData = re.rows;
                this.total = re.total;
                this.endLoading();
            }).catch(err =>{this.endLoading()});
      },
      async  handleNotGroup(row){
          try {
            this.$confirm('请确认是否取消组合商品', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async () => {
              let result = await cancelGroup({groupDesignId: row.designId})
              this.msgSuccess('取消组合成功')
              this.getList()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
          } catch (error) {
          }
        },
        resetForm() {
          this.queryParams.productType = null
          this.queryParams.remitFlag = null
          this.queryParams.timeRange = []
          let params =  {
              timeRange: null,
              designId: null,
              designProName: null,
              proName: null,
              productType: null,
              operNo: null,
              remitFlag: null,
              beginTime: null,
              endTime: null,
              delFlag: '1'
          }
          this.$refs['form'].resetFields();
        },
        tableSelectionChange(val){
          this.claimCollIds = [];
            this.claimProduct = [];
            val.forEach(r =>{
                this.claimCollIds.push(r.designId)
                this.claimProduct.push(r.designEngProName)
            });
        },
        /*跳到我的详情*/
        showDetail(row){
            this.$router.push({path:'/carry/proCustom/particulars', query: row})
        },
        /*点击加入购物车*/
        async handleShowCart(row) {
          try {
            let cartData = await getCartMatchInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {color : '', size: ''}
              let properVal = record.skuList[0].properVal.split(":")
              // record.currentAttr.color = properVal[0]
              // record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data
            // this.currentSku = cartData.data.skuList[0]
            // this.mainPic = this.currentSku.picList[0].picUrl
            this.cartDialogVisible = true
          } catch (error) {
          }
        },
          /*编辑设计*/
        async handleShowEdit(row) {
          try {
            //获取设计详情
            let cartData = await getCartMatchInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {}
              let properVal = record.skuList[0].properVal.split(":")
              record.currentAttr.color = properVal[0]
              record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data
            this.editVisible = true
          } catch (error) {
          }
        },
        handleCommandExport(command){
         if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        let platNo = ''
        if(command == 'common'){
          platNo = '09'
        }
         if(command == 'lazada'){
          platNo = '03'
        }
        if(command == 'amazon'){
          this.$router.push(`/carry/proCustom/createTemplateData?designId=${this.claimCollIds.join(',')}&name=${this.claimProduct.join('，').replace(/&/g,' ')}`)
        }else{
          this.$router.push(`/carry/common/createTemplateData?designId=${this.claimCollIds.join(',')}&name=${this.claimProduct.join('，').replace(/&/g,' ')}&platName=${command}&platNo=${platNo}`)
        }
      },
        handleSetParent(row){
           setGroupMain({designId: row.designId ,groupDesignId: row.groupDesignId}).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              for(let record of this.cartArray){
                record.groupDesignId = row.designId
              }
              this.getList()
          }).catch(err =>{

          });
        },
        handleSaveDesign(){
          this.detailInfo.remarks = this.editor.getData()
          updateDesign(this.detailInfo).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              this.editVisible = false;
          }).catch(err =>{

          });
        },


        /*确认加入购物车*/
        confirmAddCart() {
            if (this.totalCount == 0) {
                this.$message({
                    message: '请至少添加一件!',
                    type: 'warning'
                });
            } else {
                this.cartDialogVisible = false;
                let i = 0;
                this.cartData.forEach(item =>{
                    i++;
                    if (item.count != 0) {
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params); //创建购物车
                    }
                    if (this.cartData.length==i)
                        this.$message({message: "加入购物车成功", type:"success", duration: 700});
                });
                this.lastId = "";
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
            }
        },

        /*购物车弹框的计数*/
        getTotalCount(val1,obj){
            let count = 0; let price = 0.00;
            this.cartData.forEach(item =>{
                if(item.count != 0){
                    count += item.count;
                    price += item.price * item.count;
                }
            })
            this.totalCount = count;
            if (count == 0) {
                this.totalNum = 0.00;
            } else {
                this.totalNum = (price/count).toFixed(2);
            }
            this.totalPrice = price.toFixed(2);
        },
          async handleSendData(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$confirm('请确认是否推送数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await pushDesign(this.claimCollIds.join(','))
          this.msgSuccess('推送成功')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },

        /*通过商品id获取skuList*/
        getSkuList(designId) {
            if (this.lastId != designId) {
                this.lastId = designId;
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
                getDesignSku(designId).then((re) => {
                  let cacheColor = [];
                  let cacheSize = [];
                  let colors = [];
                  let sizes = [];
                    this.cartData = re.data;
                    re.data.forEach(e => {
                      if (cacheColor.indexOf(e.color) < 0) {
                        cacheColor.push(e.color);
                        colors.push(e);
                      }
                      if (cacheSize.indexOf(e.size) < 0) {
                        cacheSize.push(e.size);
                        sizes.push(e)
                      }
                      });
                    this.colors = colors;
                    this.sizes = sizes;

                })
            }
            this.cartDialogVisible = true;
        },

        handleCommand(val){
            if(this.claimCollIds.length==0){
                this.$message('请选择批量操作的数据！');
                return
            }
        },

        /*添加/修改备注*/
        addRemark(index) {
            let remark = this.tableData[index].remark;
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: remark,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                if (remark != value) {
                    this.tableData[index].remark = value;
                    updateDesign(this.tableData[index]).then(re => {
                        this.$message({
                            type: 'success',
                            message: '修改成功! 新备注是: ' + value
                        });
                    }).catch(err =>{

                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },

        //获取店铺数据
        async initPlatData(){
            let platDict;
            await this.getDicts("s_plat_code").then(res => {
                platDict = res.data;
            });
            let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
            //获取所有平台代码
            let data = [];
            platDict.forEach(dict => {
                let map ={};
                map.platNo = dict.dictValue;
                map.platName = dict.dictLabel;
                map.shopList = [];
                platCode.forEach(code =>{
                    if(dict.dictValue == code.platNo){
                        map.shopList.push(code)
                    }
                });
                data.push(map);
            });
            this.platList = data.filter(item => {return item.shopList.length > 0});
        },
        platSelect(val,row){
            let shopList = this.platList.filter(plat =>{
                return plat.platNo == val;
            });
            this.shopSelectDialog = true;
            this.shopList = shopList[0].shopList;
            this.currentRow = row;
            this.checkPlat = val;
        },

        submitSelect(){
            let that =this;
            let params = {
                designId:this.currentRow.designId,
                shopIds:this.checkedShops,
                takePlat:this.checkPlat,
                row:this.currentRow
            }
            moveToRelease(params).then(res =>{
                if (res.code == 200) {
                    that.msgSuccess("已成功移入到待发布");
                    that.shopSelectDialog = false;
                }
            }).catch(err =>{});
        },
        handleJumpToBin() {
          this.$router.push({
            path: '/carry/proCustom/recycleBin?isYx=1'
          })
        },
        // 删除当前设计
        handleDelItem(row) {
          if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
          }
          this.$confirm('是否确认删除', "警告", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(async () => {
            for(let record of this.claimCollIds){
                await updateDesign({
                  delFlag: '0',
                  designId: record
                })
            }
            this.getList();
            this.msgSuccess("删除成功");
          }).catch(function() {});
        },
        handlePickColor() {

        },
        handleEditDesign(row) {
          window.open('/design/online/designer?designId=' + row.designId)
        },
        handleReDesign(row) {
          window.open('/design/online/designer?pId=' + row.pId)
        },
        getEditor(editor){
            this.editor = editor;
        },
        handleSelectColor(record,color) {
          record.currentAttr.color = color
          this.selectSku(record)
        },
        handleSelectSize(record,size ) {
          record.currentAttr.size = size
          this.selectSku(record)
        },
        selectSku(product) {
          for (let record of product.skuList) {
            record.properVal = record.properVal.replace(/\\/g, "")
            if (
              record.properVal ===
              `${product.currentAttr.color}:${product.currentAttr.size}`
            ) {
              product.currentSku = record
              product.shop = true
              break
            }
          }
        },
    }
}
</script>

<style lang="scss" scoped>
.searchBox {
  margin-top: 1.5%;
  border: 1px solid #d7d7d7;
}

.clain-tab {
  min-width: 1200px;
}
.img-small {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 1px;
}

.el-table >>> .cell {
  max-height: 120px;
  line-height: 25px !important;
}

.el-dialog__wrapper >>> .el-dialog {
  width: 20%;
}

.cartType .el-row {
  padding: 3% 0px;
  border-bottom: 1px dashed #88888847;
  text-align: center;
}

.cart-but {
  background: #ff5561;
  width: 95%;
  height: 36px;
  font-size: 18px;
  color: white;
  margin-bottom: 2%;
  margin-left: 2%;
  line-height: 0;
}
.wrapper {
  margin-bottom: 5px;
}
.color-wrapper {
}
.color-wrapper .color-item {
  height: 40px;
  display: inline-block;
  margin-left: 5px;
  padding: 1px;
  border: 1px solid #e3e3e3;
  cursor: pointer;
}
.size-wrapper {
}
.product-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.size-wrapper .size-item {
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 1px 15px;
  border: 1px solid #f0f0f0;
  background: #f0f0f0;
  cursor: pointer;
}
.price-wrapper {
  color: #428bca;
}
.price-wrapper .price {
  font-size: 20px;
  font-weight: 800;
}
.sku-attr {
  overflow: hidden;
  margin-top: 15px;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 14px 0 0;
    float: left;
    line-height: 39px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
  }
  .sku-detail {
    width: calc(100% - 58px);
    line-height: 39px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  transition: all 0.5s ease-in-out;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 12px;
  margin: 0 8px 5px 0;

  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}
.is-select {
  border: 2px solid #f25551;
}
.sku-price {
  font-size: 20px;
}
.templateName {
  cursor: pointer;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
</style>
